import { jsx as _jsx } from "react/jsx-runtime";
import { getFeaturesEnabled } from "@/utils";
import { Box } from "@gemini/core";
import { useLoadPlato } from "./hooks";
const PlatoId = "plato.immo";
// Plato Widget entry Endpoint
// https://avivgroup.atlassian.net/wiki/spaces/ATSS/pages/1104019764/Plato+Widget+-+Technical+integration
export const Plato = () => {
    const { plato } = getFeaturesEnabled();
    useLoadPlato();
    return plato ? _jsx(Box, { id: PlatoId }) : null;
};
